import React from 'react';
import { Select, Radio, Input, InputNumber } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
const RadioGroup = Radio.Group;

function EditableCell({ editable = false, value, type, disabled = false, placeholder, onChange, style = { width: '100%' }, config }) {
    // 不可编辑
    if (!editable) {
        let result;
        switch(type) {
            case 'Select':
            case 'Radio': {
                const { options } = config || {};
                result = ((options || []).find(i => i.value == value) || {}).label;
                break;
            }
            case 'TextArea':
                style.display = 'block';
                style.whiteSpace = 'pre-wrap';
                style.wordBreak = 'break-word';
                result = value;
                break;
            default:
                result = value;
                break;
        }
        return <span style={style}>{result}</span>;
    }

    // 根据类型返回对应组件
    switch(type) {
        case 'Select': {
            const { options, allowClear, ...rest } = config || {};
            const setting = {
                ...rest,
                allowClear: allowClear || false,
            };

            let newValue = value ? String(value) : undefined;
            // options中不存在value时，清空value
            if ((options || []).every(i => i.value != newValue)) {
                newValue = undefined;
            }

            return (
                <Select
                    style={style}
                    disabled={disabled}
                    placeholder={placeholder || "请选择"}
                    {...setting}
                    value={newValue}
                    onChange={value => onChange(value)}
                >
                    { (options || []).map(i => <Option key={i.value} title={i.label}>{i.label}</Option>) }
                </Select>
            );
        }
        case 'Radio': {
            const { options } = config || {};
            return (
                <RadioGroup
                    value={value}
                    disabled={disabled}
                    onChange={e => onChange(e.target.value)}
                >
                    { (options || []).map(i => <Radio style={style} key={i.value} value={i.value}>{i.label}</Radio>) }
                </RadioGroup>
            )
        }
        case 'Number': {
            const { min, precision, ...rest } = config || {};
            const setting = {
                ...rest,
                min: min || 0,
                precision: precision || 0,
            };

            return (
                <InputNumber
                    value={value}
                    style={style}
                    disabled={disabled}
                    placeholder={placeholder || "请输入"}
                    {...setting}
                    onChange={value => onChange(value)}
                />
            );
        }
        case 'TextArea': {
            const { rows, ...rest } = config || {};
            const setting = {
                ...rest,
                rows: rows || 3,
            };

            return (
                <TextArea
                    value={value}
                    style={style}
                    disabled={disabled}
                    placeholder={placeholder || "请输入"}
                    {...setting}
                    onChange={e => onChange(e.target.value)}
                />
            );
        }
        case 'Input':
        default:
            return (
                <Input
                    value={value}
                    style={style}
                    disabled={disabled}
                    placeholder={placeholder || "请输入"}
                    onChange={e => onChange(e.target.value)}
                />
            );
    }
}

export default EditableCell;


// WEBPACK FOOTER //
// ./src/components/basicElement/EditableCell.js